<template>
  <div class='footer'>
    <span>Copyright ©2021 昆山东部软件科技有限公司 版权所有 咨询热线：0512-55136315</span>
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style scoped>
.footer {
  height: 25px;
  line-height: 25px;
  width: 100%;
  overflow: hidden;
  position: relative;
  text-align: center;
  background-color: #f8f8f8;
  color: #a3a4a6;
  font-size: 14px;
}
</style>
